export default __webpack_public_path__ + "img/train-mobile.82325857.png";